import { Box, BoxProps, ColorOptions, EmptyView, Icon, Loader, ModBox, Spacer, Text } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { ButtonNew } from '../../components/AdminButton'
import { isEmpty } from '@jfs/utils'
import { useEffect, useState } from 'react'
import { FlatList } from 'react-native'
import { List } from '../../components/List'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { TimeInput } from './TimeInput'

const getAllTime = (firstTime: string, allTimes: any[]) => {
  let allTimesCaptured = '' + firstTime
  if (allTimes?.length > 0) {
    allTimes?.map((allTime) => {
      console.log('allTime?.frequency', allTime)
      if (allTime?.time && allTime?.time?.length > 0) {
        const req = allTime?.frequency?.length > 2 ? allTime?.frequency : allTime?.time
        allTimesCaptured = `${allTimesCaptured},${req}-${allTime?.time}`
      }
    })
  }
  return allTimesCaptured
}

const isValid = (timesArr: any[]) => {
  let isAllTimeOk = true
  if (timesArr?.length > 0) {
    timesArr?.map((allTime) => {
      if (!allTime?.time || allTime?.time?.length !== 8 || !allTime?.frequency || allTime?.frequency?.length !== 8) {
        isAllTimeOk = false
      }
    })
  } else if (timesArr?.length === 0) {
    return true
  }
  return isAllTimeOk
}

const keyExtractor = (item: any): string => {
  return item?.id
}

const keyExtractorTime = (item: any): string => {
  return item?.index
}
const AddedTimeInput = ({ handleClose, getTimeSet, index, dataLength, data, key }: any) => {
  const onTimeChange = (time: any, type: any) => {
    getTimeSet(time, index, type)
  }
  const handleClosePress = () => {
    handleClose(data)
  }
  return (
    <Box width={'100%'} minHeight={35} marginTop={8} marginBottom={16}>
      <Box>
        <Box flexDirection={'row'}>
          <Box f={1}>
            <TimeInput
              value={data?.frequency ?? ''}
              onChange={(frequency) => onTimeChange(frequency, 'frequency')}
              label={'Frequency Time'}
            />
          </Box>
          <Spacer size={10} direction="horizontal" />
          <Box alignSelf={'flex-end'} marginBottom={13} onPress={handleClosePress} underlayColor={'TRANSPARENT'}>
            <Icon id="CLOSE" size={16} color="PRIMARY" />
          </Box>
        </Box>
        <Spacer size={10} direction="horizontal" />
        <Box>
          <TimeInput value={data?.time ?? ''} onChange={(time) => onTimeChange(time, 'time')} label={'Cut-Off Time'} />
        </Box>
      </Box>

      {/* <Box direction="row" w={240} marginTop={4} key={key}>
        <Box w={220} bg={'WHITE'}>
          <TimeInput value={data?.time} onChange={onTimeChange} label={'Start Time'} key={key} />
        </Box>
        <ModBox align="center" onPress={handleClosePress} underlayColor={'TRANSPARENT'} marginTop={4} marginRight={-8}>
          <Icon id="CLOSE" size={16} color="PRIMARY" />
        </ModBox>
      </Box> */}
    </Box>
  )
}

const headTitles = [{ id: 'Id' }, { startTime: 'Start Time' }, { interval: 'Interval' }, { description: 'Description' }]

const PayoutConfig = () => {
  const [interval, setFrequencyInterval] = useState('')
  const [startTime, setStartTime] = useState('')
  const [startFrequency, setStartFrequency] = useState('')
  const [description, setDescription] = useState('')
  const [allTimeList, setAllTimeList] = useState([])
  const [intervalError, setIntervalError] = useState('')

  const [count, setCount] = useState(0)

  const { update, fetchPayoutFrequencyConfig, getAllConfigs, accessConfig, config, getFilteredFreuencyConfigList } =
    useStores((store) => ({
      update: store.payoutFrequencyConfig.updatePayoutFrequencyConfig,
      fetchPayoutFrequencyConfig: store.payoutFrequencyConfig.fetchPayoutFrequencyConfig,
      getAllConfigs: store.payoutFrequencyConfig.getAllConfigs,
      getFilteredFreuencyConfigList: store.payoutFrequencyConfig.getFilteredFreuencyConfigList,
      config: store.user.accessConfig,
      accessConfig: store.user.getAccessConfig(['ess', 'payout_frequency_config']),
    }))

  const [lazyFetchPayoutFrequencyConfig, { state: retrieveState, data: retrieveApiData }] =
    useLazyApiData(fetchPayoutFrequencyConfig)
  const isFetchAccessible = isAccessible(accessConfig, 'fetch')

  useEffect(() => {
    isFetchAccessible && lazyFetchPayoutFrequencyConfig()
  }, [config])

  const [lazyUpdate, { state }] = useLazyApiData(update)

  const onIntervalChange = (val) => {
    const onlyNumbers = val.replace(/[^0-9]/g, '')
    setFrequencyInterval(onlyNumbers)
  }

  useEffect(() => {
    if (state === 'fulfilled') {
      resetFormValues()
      isFetchAccessible && lazyFetchPayoutFrequencyConfig()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])
  const listData = getAllConfigs()

  const resetFormValues = () => {
    setFrequencyInterval('')
    setStartTime('')
    setStartFrequency('')
    setDescription('')
    setAllTimeList([])
  }

  const onRetry = () => {
    isFetchAccessible && lazyFetchPayoutFrequencyConfig()
  }

  const handleAddNewTime = () => {
    const reOrdered = allTimeList?.map((item, index) => ({ ...item, index: index }))
    reOrdered.push({ index: allTimeList?.length + 1, time: '', frequency: '' })
    setAllTimeList(reOrdered)
    if (reOrdered?.length) {
      setFrequencyInterval('1440')
    } else {
      setFrequencyInterval('')
    }
  }

  const removeConfig = (item: any) => {
    setCount((prevCount) => prevCount - 1)
    const filteredArr = allTimeList?.filter((essConfig: any) => item?.index !== essConfig.index)
    const reOrdered = filteredArr?.map((essConfig: any, index: number) => ({ ...essConfig, index: index }))
    setAllTimeList(reOrdered)
  }

  const setNewlyAddedTimeList = (timeSet: any, index: number, type: any) => {
    let updatedTimeList = allTimeList?.filter((allTime) => allTime?.index === index + 1)
    if (updatedTimeList?.length) {
      let newConfig = {
        ...updatedTimeList[0],
      }
      newConfig[type] = timeSet
      const updatedArr = [...allTimeList?.filter((allTime) => allTime?.index !== index + 1), { ...newConfig }]
      setAllTimeList(updatedArr)
    }
  }

  const onInputChange = (time, type) => {
    if (type === 'time') {
      setStartTime(time)
    } else if (type === 'frequency') {
      setStartFrequency(time)
    }
  }

  const disableBtn = (): boolean => {
    if (isEmpty(interval) && !isEmpty(intervalError)) {
      setIntervalError('')
      return true
    }
    if (!isEmpty(interval) && 1440 % Number(interval) !== 0) {
      if (intervalError !== 'Interval should factor of 1440') {
        setIntervalError('Interval should factor of 1440')
      }
      return true
    }
    if (!isEmpty(interval) && Number(interval) > 1440) {
      if (intervalError !== 'Interval should be less than 1440') {
        setIntervalError('Interval should be less than 1440')
      }
      return true
    }
    if (intervalError !== '') {
      setIntervalError('')
    }
    if (Number(interval) < 1440 && 1440 % Number(interval) === 0) {
      return false
    }
    const validStartTime = !isEmpty(startTime) && startTime?.length === 8
    const validFrequencyTime = !isEmpty(startFrequency) && startFrequency?.length === 8
    const isFirstTimeInvalid = !validStartTime || !validFrequencyTime || isEmpty(interval)
    const invalidForm = allTimeList?.length ? isFirstTimeInvalid || !isValid(allTimeList) : isFirstTimeInvalid

    return invalidForm
  }

  return (
    <Box {...styles.container}>
      <Text title={'Payout Frequency Config'} fontSize={28} fontWeight={'600'} color={'#5a5c69' as ColorOptions} />

      <Spacer direction="vertical" size={35} />
      <Box align="center" justify="center">
        <Box minWidth={340}>
          <Box opacity={allTimeList?.length > 0 ? 0.5 : 1}>
            <TextInputNew
              textWidth={220}
              label={'Set Interval in minutes'}
              editable={allTimeList?.length === 0}
              value={allTimeList?.length > 0 ? '1440' : interval}
              onChangeText={onIntervalChange}
              borderColor={'PRIMARY_GREY' as ColorOptions}
              labelFontFamily={'jiotype-medium'}
              fontSize={12}
              error={intervalError}
              paddingHorizontal={8}
              paddingVertical={12}
              borderRadius={4}
              labelColor={'PRIMARY_GREY'}
              labelPaddingBottom={10}
              type="body12"
              touched
            />
          </Box>
          {!isEmpty(interval) && Number(interval) === 1440 && (
            <>
              <Box>
                <Box bg={'WHITE'}>
                  <Box flexDirection={'row'}>
                    <Box f={1}>
                      <TimeInput
                        value={startFrequency}
                        onChange={(time) => onInputChange(time, 'frequency')}
                        label={'Frequency Time'}
                      />
                    </Box>
                    <Spacer size={10} direction="horizontal" />
                    <Box
                      alignSelf={'flex-end'}
                      marginBottom={13}
                      onPress={handleAddNewTime}
                      underlayColor={'TRANSPARENT'}>
                      <Icon id="ADD" size={16} color="PRIMARY" />
                    </Box>
                  </Box>
                  <Spacer size={10} direction="horizontal" />
                  <Box>
                    <TimeInput
                      value={startTime}
                      onChange={(time) => onInputChange(time, 'time')}
                      label={'Cut-Off Time'}
                    />
                  </Box>
                </Box>
              </Box>
              <ModBox marginTop={8}>
                <FlatList
                  keyExtractor={keyExtractorTime}
                  data={allTimeList}
                  renderItem={({ item, index }) => (
                    <AddedTimeInput
                      handleClose={removeConfig}
                      getTimeSet={setNewlyAddedTimeList}
                      index={index}
                      dataLength={allTimeList?.length}
                      data={item}
                      key={index}
                    />
                  )}
                  extraData={allTimeList}
                />
              </ModBox>
            </>
          )}
          <Spacer direction="vertical" size={16} />
          <TextInputNew
            textWidth={220}
            label={'Description'}
            value={description}
            onChangeText={setDescription}
            borderColor={'PRIMARY_GREY' as ColorOptions}
            labelFontFamily={'jiotype-medium'}
            fontSize={12}
            paddingHorizontal={8}
            paddingVertical={12}
            borderRadius={4}
            labelColor={'PRIMARY_GREY'}
            labelPaddingBottom={10}
            type="body12"
          />
          <Spacer direction="vertical" size={16} />
          <Box alignItems="center" justify="center" flexDirection={'row'}>
            <ButtonNew
              borderColor={'PRIMARY'}
              type={'secondary'}
              onPress={resetFormValues}
              title={'Reset'}
              height={36}
              borderRadius={3}
            />
            <Spacer direction="horizontal" size={16} />
            <ButtonNew
              onPress={() => {
                // do update config
                const startTimeStr = getAllTime(
                  `${startFrequency}-${startTime?.length ? startTime : startFrequency}`,
                  allTimeList,
                )
                if (Number(interval) < 1440) {
                  console.log('startTimeStr', startTimeStr, startFrequency)
                  lazyUpdate({
                    startTime: '00:00:00',
                    interval: interval,
                    description: description,
                  })
                } else {
                  console.log('startTimeStr', startTimeStr, startFrequency)
                  lazyUpdate({
                    startTime: startTimeStr,
                    interval: interval,
                    description: description,
                  })
                }
              }}
              title={'Save'}
              height={36}
              borderRadius={3}
              hide={!isAccessible(accessConfig, 'add')}
              disabled={disableBtn()}
              isLoading={state === 'pending'}
            />
          </Box>
        </Box>
      </Box>
      <Spacer direction="vertical" size={32} />
      <ModBox show={isAccessible(accessConfig, 'fetch')}>
        <Text title={'Payout Frequency List'} fontSize={24} fontWeight={'600'} color={'#5a5c69' as ColorOptions} />
        <Spacer direction="vertical" size={16} />
        <EmptyView
          onRetry={onRetry}
          isLoading={retrieveState === 'pending'}
          loaderComponent={<Loader type="small" color="PRIMARY" />}
          emptyMessage={listData?.length === 0 ? 'No records found' : retrieveApiData?.message}
          error={
            retrieveApiData?.message && { networkError: { data: { errors: [{ details: retrieveApiData?.message }] } } }
          }
        />
        <ModBox
          show={isAccessible(accessConfig, 'fetch') && listData?.length > 0 && retrieveState === 'fulfilled'}
          f={1}>
          <List
            keyExtractor={keyExtractor}
            headTitle={headTitles}
            numOfColumns={4}
            sizeConfig={[1, 2, 1.75, 1.75]}
            data={listData}
            listTitle={'Frequency Config List'}
            isColumnSearchEnabled={true}
            getFilteredData={getFilteredFreuencyConfigList}
          />
        </ModBox>
      </ModBox>
    </Box>
  )
}

const styles = {
  container: {
    h: '100%',
    bg: 'WHITE',
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
    borderRadius: 8,
    p: 20,
    overflow: 'auto',
  } as BoxProps,
}
export default PayoutConfig
